// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .no-header {
   background-color: #ffffff;
}

.fixed-toolbar-task {
   align-items: center;
   background-color: #fff;
   border-bottom: 1px solid #eaeaea;
   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);
   position: fixed;
   left: 240px;
   right: 0;
   padding-left: 20px;
   z-index: 5;
   height: 50px;
}

.fixed-toolbar-task ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

@media (min-width: 0px) and (max-width: 1366px) {
   #left{
      float: left;
   }
   #right{
      float: left;
      margin-right: -60px;
   }
   .title_right{
      margin-left: 0px !important;
      margin-right: -150px !important;
   }
}

@media (min-width: 1367px) and (max-width: 1980px)  {
   #left{
      float: left;
   }
   #right{
      float: left;
      margin-right: 100px;
   }
   .title_right{
      margin-left: 100px !important;
      margin-right: 0px !important;
   }
}

/* css for ie */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .fixed-toolbar-task {
      align-items: center;
      background-color: #fff;
      border-bottom: 1px solid #eaeaea;
      box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);
      position: fixed;
      left: 240px;
      right: 10vh;
      padding-left: 20px;
      z-index: 5;
      height: 50px;
   }
}

/* ------------- */

app-tasklist {
   margin: 50px 20px 20px;
   position: relative;
   transition: background-color .3s, opacity .3s;
}

.browse-folder {
   display: inline-block;
   margin-right: 5px;
   width: 24px;
   height: 24px;
   vertical-align: text-bottom;
}

.toolbar {
   align-items: center;
   padding-right: 20px;
}

.menu > li {
   float: left;
}

.menu > li > a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open > a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu {
   list-style: none;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.menu span + em {
   margin-left: 10px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.drag-over {
   background-color: rgba(0, 188, 212, .2);
   opacity: .5;
}

/* Full-width inputs */
input[type=text], input[type=password], input[type=email] {
   width: 70%;
   padding: 10px 15px;
   margin: 0 0;
   display: inline-block;
   border: 1px solid #ccc;
   box-sizing: border-box;
}

.btn-x {
   margin-top: 5px;
   font-size: 18px;
}

/* Set a style for all buttons */
/*button {*/
/*background-color: #333;*/
/*color: white;*/
/*padding: 15px 20px;*/
/*margin: 8px 0;*/
/*border: none;*/
/*cursor: pointer;*/
/*width: 100%;*/
/*margin: auto;*/
/*}*/

/* Extra style for the cancel button (red) */
.regisbtn {
   width: auto;
   padding: 10px 18px;
   background-color: #f44336;
}

/* Center the avatar image inside this container */
.imgcontainer {
   text-align: center;
   margin: 24px 0 12px 0;
}

/* Avatar image */
img.avatar {
   width: 30%;
   border-radius: 50%;
   /*margin-top: 50px;*/
}

/* Add padding to containers */
.container {
   padding: 16px;
}

/* The "Forgot password" text */
span.psw {
   float: right;
   padding-top: 16px;
}

/* Change styles for span and cancel button on extra small screens */
@media screen and (max-width: 300px) {
   span.psw {
      display: block;
      float: none;
   }

   .cancelbtn {
      width: 100%;
   }

}

.wrapper {
   text-align: center;
   /*text-align: left;*/
}

.star {
   font-size: 25px;
   color: grey;
}

nav {
   float: left;
   max-width: 160px;
   margin: 0;
   padding: 1em;
}

nav ul {
   list-style-type: none;
   height: 100%;
   position: fixed;
   width: 15%;
   background-color: #f4f5f7;
   overflow: auto;
}

nav ul a {
   text-decoration: none;
   display: block;
   color: #000;
   padding: 8px 16px;
}

#div2, #div3, #div4 {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

#snackbar {
   visibility: hidden;
   min-width: 250px;
   margin-left: -125px;
   background-color: #333;
   color: #fff;
   text-align: center;
   border-radius: 2px;
   padding: 16px;
   position: fixed;
   z-index: 1;
   left: 50%;
   bottom: 30px;
   font-size: 17px;
}

#snackbar.show {
   visibility: visible;
   animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

.errorBox.show {
   visibility: visible;
   animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@keyframes fadein {
   from {
      bottom: 0;
      opacity: 0;
   }
   to {
      bottom: 30px;
      opacity: 1;
   }
}

@keyframes fadeout {
   from {
      bottom: 30px;
      opacity: 1;
   }
   to {
      bottom: 0;
      opacity: 0;
   }
}

#drop_zone.hover {
   color: #f00;
   border: solid #f00;
   box-shadow: inset 0 3px 4px #888;
}

#drop_zone {
   font-weight: bold;
   text-align: center;
   padding: 1em 0;
   margin: 1em 0;
   color: #555;
   border: 2px dashed #555;
   border-radius: 7px;
   cursor: default;
}

#noFiles {
   font-weight: bold;
   text-align: center;
   padding: 1em 0;
   margin: 1em 0;
   color: #555;
   /*border: 2px dashed #555;*/
   border-radius: 7px;
   cursor: default;
}

#div1 {
   width: 350px;
   height: 70px;
   padding: 10px;
   border: 1px solid #aaa;
}

#body_drop_zone {
   /*height: 65%;*/
   /*overflow: auto;*/
}

#progressDlg {
   /*animation: progressBar 3s ease-in-out;*/
   /*animation-fill-mode:both;*/
   -webkit-animation-name: example; /* Chrome, Safari, Opera */
   -webkit-animation-duration: 5s; /* Chrome, Safari, Opera */
   animation-name: example;
   animation-duration: 5s;
   animation-iteration-count: infinite;
}

@keyframes example {

   0% {
      background: #ff4d4d;
   }
   25% {
      background: #f66;
   }
   50% {
      background: #f99;
   }
   75% {
      background: #ffe5e5;
   }
   100% {
      background: #ff4d4d;
   }

   /*from {background-color:  #ff4d4d;}*/
   /*to {background-color: #ff6666;}*/
   /*to {background-color: #ff9999;}*/
   /*to {background-color: #ffe5e5;}*/
   /*to {background-color: white;}*/
}

#sideLeftdiv {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

#sideLeft {
   height: 65%;
   overflow-y: auto;
   /*overflow-x: hidden;*/
}

.modal-header {
   padding: 10px;
}

.modal-footer {
   padding: 10px;
}

/*@keyframes progressBar {*/
/*!*0% { width: 0; }*!*/
/*!*100% { width: 100%; }*!*/
/**/
/*}*/

/*@-webkit-keyframes progressBar {*/
/*0% {*/
/*background: hsl(15, 0%, 52%);*/
/*width: 0%;*/
/*}*/
/*70% {*/
/*border-radius: 10px 0 0 10px;*/
/*}*/
/*100% {*/
/*background: hsl(15, 100%, 72%);*/
/*width: 100%;*/
/*border-radius: 10px;*/
/*}*/
/*}*/

.btnicon:before {
   font-family: "Glyphicons Halflings", sans-serif;
   content: "\\e114";
   font-size: 14px;
   margin-right: 5px
}

/* Icon when the collapsible content is hidden */
.btnicon.collapsed:before {
   content: "\\e080";
}

h5 {
   /*width: 60%;*/
   word-wrap: break-word;
   font-family: Arial, Helvetica, sans-serif;
   font-style: normal;
}

#sideBarLeft {
   /*border: 2px solid;*/
   /*padding: 20px;*/
   width: 150px;
   min-width: 150px;
   max-width: 350px;
   resize: horizontal;
   overflow: hidden;
   /*overflow: auto;*/
}

.disabledbutton {
   background-color: gainsboro;
   border-color: gainsboro;
}

.dlgProgress2 {
   right: 20px;
   top: 400px;
   position: absolute;
   height: auto;
   min-width: 360px;
   max-width: 400px;
   background-color: #fff;
   border: 1px solid #ccc;
   box-shadow: 1px 0 8px rgba(0, 0, 0, 0.3);
   color: #333;
   /*margin-top: 3px;*/
   z-index: 1000;
}

.floating-box {
   float: left;
   width: 300px;
   height: 100px;
   margin: 10px;
   border: 3px solid #73ad21;
}

.after-box {
   clear: left;
   border: 3px solid red;
}

.modal-content {
   margin: auto;
   background-color: #fff;
   position: relative;
   padding: 0;
   outline: 0;
   width: 600px
}

.modal {
   z-index: 100;
   display: none;
   padding-top: 100px;
   position: fixed;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   overflow: auto;
   background-color: rgb(0, 0, 0);
   background-color: rgba(0, 0, 0, 0.4)
}

.example-card {
   width: 400px;
   background-color: white;
   left: 40%;
   border: 1px solid #364150;
}

.example-section {
   display: flex;
   align-content: center;
   align-items: center;
   height: 60px;
}

.example-margin {
   margin: 0 10px;
}

.header_modal {
   /*border-bottom: 1px solid #364150;*/
   border-bottom: 1px solid #999;
}

.header_modal p {
   color: #364150;
   font-size: 20px;
   /*font-family: 'Open Sans';*/
   /*font-weight: bold;*/
}

.footer_modal {
   text-align: right;
   margin-top: -15px;
   /*margin: 5px*/
}

.footer_modal button {
   /*font-family: 'Open Sans';*/
   /*font-weight: bold;*/
   margin-top: 10px;
}

#footerbutton {
   border-top: 1px solid #364150;
   margin-top: 10px;
}

.icon {
   width: 27px;
   height: 30px;
   margin-right: 20px;
   margin-bottom: -2px;
   cursor: pointer;
}

.icon-two {
   width: 27px;
   height: 30px;
   margin-right: 20px;
   margin-bottom: -2px;
   cursor: pointer;
}

.task-list {
   width: 98%;
   max-height: 100%;
   transition: background-color .3s, opacity .3s;

   display: flex;
   flex-direction: column;
   flex: 1;
   overflow: auto;
   position: relative;
}

.app-tasklist {
   margin: 5px 20px 20px;
   position: relative;
   transition: background-color .3s, opacity .3s;
}

.mat-column-select {
   overflow: visible;
}

.workflow-shadow {
   box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0), 10px 0px 14px 0px rgba(0, 0, 0, 0.12);
}

.loading-shade {
   position: absolute;
   top: 0;
   left: 0;
   bottom: 56px;
   right: 0;
   background: rgba(0, 0, 0, 0.15);
   z-index: 1;
   display: flex;
   align-items: center;
   justify-content: center;
}

.div-table {
   overflow: auto !important;
}

.mat-form-field {
   font-size: 14px;
   width: 100%;
}

table {
   width: 100%;
}

th.mat-sort-header-sorted {
   color: black;
}

.task-row {
   overflow: auto;
   height: 10px;
}

/*.taskname {*/
/*   display: flex !important;*/
/*   text-overflow: ellipsis;*/
/*   white-space: nowrap;*/
/*   overflow: hidden !important;*/
/*   max-width: calc(30em * 0.5);*/
/*   min-width: 100%;*/
/*}*/
.taskname {
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
}

.taskname-content {
   display: flex;
   align-items: center;
   width: 100%;
   overflow: hidden;
}

.file-icon img {
   display: block;
   margin: 8px;
   width: 22px;
   height: 22px;
   object-fit: contain;
}
.file-icon img.cover {
   object-fit: cover;
}
.file-filename {
   padding: 10px 0;
}
.file-filename a {
   cursor: pointer;
}
.file-name {
   align-items: center;
   display: inline-flex;
   max-width: 100%;
}
.file-name a, .file-name .name {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.file-name .link {
   fill: #ba68c8;
   cursor: pointer;
   display: inline-block;
   margin-left: 10px;
   width: 14px;
   height: 14px;
}
.item-top {
   vertical-align: top;
   padding-top: 8px;
}

.container-new-task {
   flex: 1;
   background: #fff;
   margin: 50px 10px 10px;
}

.right-panel {
   background: #fff;
   width: 320px;
   min-width: 320px;
   overflow-y: auto;
   transition: margin-right .2s;
}

.content-panel {
   display: flex;
   flex-direction: column;
   margin: 0px 10px;
}

.sub-header {
   color: #aaa;
}

.content-panel img {
   width: 22px;
   height: 22px;
   position: absolute;
   left: -22px;
   top: 4px;
}

.content-panel ul {
   list-style: none;
   margin: 10px 0 0;
   padding: 0;
}

.content-panel li {
   margin: 5px 0 5px 5px;
   line-height: 20px;
   position: relative;
}

.content-panel li.section {
   font-weight: bold;
   padding: 5px 5px 5px 20px;
}

.content-panel a{
   color: #666;
   display: flex;
   line-height: 20px;
   padding: 5px 5px 5px 0;
   position: relative;
}

.content-panel a:hover {
   color: #ffa726;
   cursor: pointer;
   background-color: #f7f7f7;
   text-decoration: none;
}

.content-panel a:active {
   color: #ff8326;
   cursor: default;
}

.content-panel a.active {
   color: #ff8326;
   cursor: default;
}

.content-panel a.active:hover {
   text-decoration: none;
}

.content_header {
   width: 100%;
   position: sticky;
   top: 0;
   z-index: 999;
   background: #FFFFFF;
   padding-bottom: 10px;
}

.isDisabled {
   cursor: not-allowed;
   opacity: 0.5;
 }
 .isDisabled > a {
   color: currentColor;
   display: inline-block;  /* For IE11/ MS Edge bug */
   pointer-events: none;
   text-decoration: none;
 }
.itemMenu-img {
   margin-right: 14px !important;
   object-fit: contain;
}

::ng-deep .sub-menu-export svg {
   margin-right: auto;
}

.sub-menu-export {
   padding-right: 30px;
}
.group-by{
   z-index: 1;
   margin: 0 0 0 10px!important;
   white-space: nowrap;
}
.flex-container {
   float: right!important;
   display: flex;
   align-items: center;
   justify-content: flex-end;
}

#paginator {
   flex: 0 0 auto;
}

::ng-deep #paginator .range {
   white-space: nowrap;
}

.mat-column-select {
   width: 36px;
   max-width: 36px;
   min-width: 36px;
   padding: 0 !important;
   text-align: center;
}
.checkbox-wrapper {
   display: flex;
   align-items: center;
   justify-content: center;
}

.checkbox-wrapper mat-checkbox {
   margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/tasks/tasks.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;AAC5B;;AAEA;GACG,mBAAmB;GACnB,sBAAsB;GACtB,gCAAgC;GAChC,6CAA6C;GAC7C,eAAe;GACf,WAAW;GACX,QAAQ;GACR,kBAAkB;GAClB,UAAU;GACV,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG;MACG,WAAW;GACd;GACA;MACG,WAAW;MACX,mBAAmB;GACtB;GACA;MACG,2BAA2B;MAC3B,+BAA+B;GAClC;AACH;;AAEA;GACG;MACG,WAAW;GACd;GACA;MACG,WAAW;MACX,mBAAmB;GACtB;GACA;MACG,6BAA6B;MAC7B,4BAA4B;GAC/B;AACH;;AAEA,eAAe;AACf;GACG;MACG,mBAAmB;MACnB,sBAAsB;MACtB,gCAAgC;MAChC,6CAA6C;MAC7C,eAAe;MACf,WAAW;MACX,WAAW;MACX,kBAAkB;MAClB,UAAU;MACV,YAAY;GACf;AACH;;AAEA,kBAAkB;;AAElB;GACG,sBAAsB;GACtB,kBAAkB;GAClB,6CAA6C;AAChD;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,2BAA2B;AAC9B;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,uCAAuC;GACvC,WAAW;AACd;;AAEA,sBAAsB;AACtB;GACG,UAAU;GACV,kBAAkB;GAClB,WAAW;GACX,qBAAqB;GACrB,sBAAsB;GACtB,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,eAAe;AAClB;;AAEA,gCAAgC;AAChC,WAAW;AACX,0BAA0B;AAC1B,gBAAgB;AAChB,sBAAsB;AACtB,iBAAiB;AACjB,gBAAgB;AAChB,mBAAmB;AACnB,eAAe;AACf,gBAAgB;AAChB,IAAI;;AAEJ,4CAA4C;AAC5C;GACG,WAAW;GACX,kBAAkB;GAClB,yBAAyB;AAC5B;;AAEA,kDAAkD;AAClD;GACG,kBAAkB;GAClB,qBAAqB;AACxB;;AAEA,iBAAiB;AACjB;GACG,UAAU;GACV,kBAAkB;GAClB,oBAAoB;AACvB;;AAEA,8BAA8B;AAC9B;GACG,aAAa;AAChB;;AAEA,+BAA+B;AAC/B;GACG,YAAY;GACZ,iBAAiB;AACpB;;AAEA,oEAAoE;AACpE;GACG;MACG,cAAc;MACd,WAAW;GACd;;GAEA;MACG,WAAW;GACd;;AAEH;;AAEA;GACG,kBAAkB;GAClB,oBAAoB;AACvB;;AAEA;GACG,eAAe;GACf,WAAW;AACd;;AAEA;GACG,WAAW;GACX,gBAAgB;GAChB,SAAS;GACT,YAAY;AACf;;AAEA;GACG,qBAAqB;GACrB,YAAY;GACZ,eAAe;GACf,UAAU;GACV,yBAAyB;GACzB,cAAc;AACjB;;AAEA;GACG,qBAAqB;GACrB,cAAc;GACd,WAAW;GACX,iBAAiB;AACpB;;AAEA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;GAChB,mBAAmB;GACnB,sBAAsB;GACtB,WAAW;GACX,kBAAkB;GAClB,kBAAkB;GAClB,aAAa;GACb,eAAe;GACf,UAAU;GACV,SAAS;GACT,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,mBAAmB;GAEnB,yCAAyC;AAC5C;;AAEA;GACG,mBAAmB;GAEnB,yCAAyC;AAC5C;;AAaA;GACG;MACG,SAAS;MACT,UAAU;GACb;GACA;MACG,YAAY;MACZ,UAAU;GACb;AACH;;AAaA;GACG;MACG,YAAY;MACZ,UAAU;GACb;GACA;MACG,SAAS;MACT,UAAU;GACb;AACH;;AAEA;GACG,WAAW;GACX,kBAAkB;GAClB,gCAAgC;AACnC;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;GAClB,cAAc;GACd,aAAa;GACb,WAAW;GACX,uBAAuB;GACvB,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;GAClB,cAAc;GACd,aAAa;GACb,WAAW;GACX,2BAA2B;GAC3B,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,YAAY;GACZ,YAAY;GACZ,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,yCAAyC;GACzC,4BAA4B;GAC5B,+BAA+B,EAAE,0BAA0B;GAC3D,8BAA8B,EAAE,0BAA0B;GAC1D,uBAAuB;GACvB,sBAAsB;GACtB,mCAAmC;AACtC;;AAEA;;GAEG;MACG,mBAAmB;GACtB;GACA;MACG,gBAAgB;GACnB;GACA;MACG,gBAAgB;GACnB;GACA;MACG,mBAAmB;GACtB;GACA;MACG,mBAAmB;GACtB;;GAEA,qCAAqC;GACrC,kCAAkC;GAClC,kCAAkC;GAClC,kCAAkC;GAClC,gCAAgC;AACnC;;AAEA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,WAAW;GACX,gBAAgB;GAChB,sBAAsB;AACzB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;AAChB;;AAEA,2BAA2B;AAC3B,uBAAuB;AACvB,4BAA4B;AAC5B,GAAG;AACH,IAAI;;AAEJ,mCAAmC;AACnC,OAAO;AACP,gCAAgC;AAChC,aAAa;AACb,IAAI;AACJ,QAAQ;AACR,gCAAgC;AAChC,IAAI;AACJ,SAAS;AACT,kCAAkC;AAClC,eAAe;AACf,uBAAuB;AACvB,IAAI;AACJ,IAAI;;AAEJ;GACG,+CAA+C;GAC/C,gBAAgB;GAChB,eAAe;GACf;AACH;;AAEA,gDAAgD;AAChD;GACG,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,qBAAqB;GACrB,yCAAyC;GACzC,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,2BAA2B;GAC3B,uBAAuB;AAC1B;;AAEA;GACG,WAAW;GACX,UAAU;GACV,kBAAkB;GAClB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,sBAAsB;GACtB,sBAAsB;GACtB,wCAAwC;GACxC,WAAW;GACX,mBAAmB;GACnB,aAAa;AAChB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,aAAa;GACb,YAAY;GACZ,yBAAyB;AAC5B;;AAEA;GACG,WAAW;GACX,qBAAqB;AACxB;;AAEA;GACG,YAAY;GACZ,sBAAsB;GACtB,kBAAkB;GAClB,UAAU;GACV,UAAU;GACV;AACH;;AAEA;GACG,YAAY;GACZ,aAAa;GACb,kBAAkB;GAClB,eAAe;GACf,OAAO;GACP,MAAM;GACN,WAAW;GACX,YAAY;GACZ,cAAc;GACd,8BAA8B;GAC9B;AACH;;AAEA;GACG,YAAY;GACZ,uBAAuB;GACvB,SAAS;GACT,yBAAyB;AAC5B;;AAEA;GACG,aAAa;GACb,qBAAqB;GACrB,mBAAmB;GACnB,YAAY;AACf;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,oCAAoC;GACpC,6BAA6B;AAChC;;AAEA;GACG,cAAc;GACd,eAAe;GACf,4BAA4B;GAC5B,qBAAqB;AACxB;;AAEA;GACG,iBAAiB;GACjB,iBAAiB;GACjB,cAAc;AACjB;;AAEA;GACG,4BAA4B;GAC5B,qBAAqB;GACrB,gBAAgB;AACnB;;AAEA;GACG,6BAA6B;GAC7B,gBAAgB;AACnB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,mBAAmB;GACnB,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,mBAAmB;GACnB,eAAe;AAClB;;AAEA;GACG,UAAU;GACV,gBAAgB;GAChB,6CAA6C;;GAE7C,aAAa;GACb,sBAAsB;GACtB,OAAO;GACP,cAAc;GACd,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,kBAAkB;GAClB,6CAA6C;AAChD;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,qHAAqH;AACxH;;AAEA;GACG,kBAAkB;GAClB,MAAM;GACN,OAAO;GACP,YAAY;GACZ,QAAQ;GACR,+BAA+B;GAC/B,UAAU;GACV,aAAa;GACb,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,eAAe;GACf,WAAW;AACd;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,cAAc;GACd,YAAY;AACf;;AAEA,cAAc;AACd,+BAA+B;AAC/B,8BAA8B;AAC9B,0BAA0B;AAC1B,kCAAkC;AAClC,kCAAkC;AAClC,sBAAsB;AACtB,IAAI;AACJ;GACG,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,WAAW;GACX,WAAW;GACX,YAAY;GACZ,mBAAmB;AACtB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,eAAe;AAClB;AACA;GACG,eAAe;AAClB;AACA;GACG,mBAAmB;GACnB,oBAAoB;GACpB,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;AACA;GACG,aAAa;GACb,eAAe;GACf,qBAAqB;GACrB,iBAAiB;GACjB,WAAW;GACX,YAAY;AACf;AACA;GACG,mBAAmB;GACnB,gBAAgB;AACnB;;AAEA;GACG,OAAO;GACP,gBAAgB;GAChB,sBAAsB;AACzB;;AAEA;GACG,gBAAgB;GAChB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,4BAA4B;AAC/B;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,gBAAgB;AACnB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,WAAW;GACX,QAAQ;AACX;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;GAChB,UAAU;AACb;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,iBAAiB;GACjB,yBAAyB;AAC5B;;AAEA;GACG,WAAW;GACX,aAAa;GACb,iBAAiB;GACjB,sBAAsB;GACtB,kBAAkB;AACrB;;AAEA;GACG,cAAc;GACd,eAAe;GACf,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,WAAW;GACX,gBAAgB;GAChB,MAAM;GACN,YAAY;GACZ,mBAAmB;GACnB,oBAAoB;AACvB;;AAEA;GACG,mBAAmB;GACnB,YAAY;CACd;CACA;GACE,mBAAmB;GACnB,qBAAqB,GAAG,0BAA0B;GAClD,oBAAoB;GACpB,qBAAqB;CACvB;AACD;GACG,6BAA6B;GAC7B,mBAAmB;AACtB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;AACtB;AACA;GACG,UAAU;GACV,4BAA4B;GAC5B,mBAAmB;AACtB;AACA;GACG,sBAAsB;GACtB,aAAa;GACb,mBAAmB;GACnB,yBAAyB;AAC5B;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;GACX,eAAe;GACf,eAAe;GACf,qBAAqB;GACrB,kBAAkB;AACrB;AACA;GACG,aAAa;GACb,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,SAAS;AACZ","sourcesContent":["::ng-deep .no-header {\n   background-color: #ffffff;\n}\n\n.fixed-toolbar-task {\n   align-items: center;\n   background-color: #fff;\n   border-bottom: 1px solid #eaeaea;\n   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n   position: fixed;\n   left: 240px;\n   right: 0;\n   padding-left: 20px;\n   z-index: 5;\n   height: 50px;\n}\n\n.fixed-toolbar-task ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n@media (min-width: 0px) and (max-width: 1366px) {\n   #left{\n      float: left;\n   }\n   #right{\n      float: left;\n      margin-right: -60px;\n   }\n   .title_right{\n      margin-left: 0px !important;\n      margin-right: -150px !important;\n   }\n}\n\n@media (min-width: 1367px) and (max-width: 1980px)  {\n   #left{\n      float: left;\n   }\n   #right{\n      float: left;\n      margin-right: 100px;\n   }\n   .title_right{\n      margin-left: 100px !important;\n      margin-right: 0px !important;\n   }\n}\n\n/* css for ie */\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n   .fixed-toolbar-task {\n      align-items: center;\n      background-color: #fff;\n      border-bottom: 1px solid #eaeaea;\n      box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n      position: fixed;\n      left: 240px;\n      right: 10vh;\n      padding-left: 20px;\n      z-index: 5;\n      height: 50px;\n   }\n}\n\n/* ------------- */\n\napp-tasklist {\n   margin: 50px 20px 20px;\n   position: relative;\n   transition: background-color .3s, opacity .3s;\n}\n\n.browse-folder {\n   display: inline-block;\n   margin-right: 5px;\n   width: 24px;\n   height: 24px;\n   vertical-align: text-bottom;\n}\n\n.toolbar {\n   align-items: center;\n   padding-right: 20px;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu {\n   list-style: none;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu span + em {\n   margin-left: 10px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.drag-over {\n   background-color: rgba(0, 188, 212, .2);\n   opacity: .5;\n}\n\n/* Full-width inputs */\ninput[type=text], input[type=password], input[type=email] {\n   width: 70%;\n   padding: 10px 15px;\n   margin: 0 0;\n   display: inline-block;\n   border: 1px solid #ccc;\n   box-sizing: border-box;\n}\n\n.btn-x {\n   margin-top: 5px;\n   font-size: 18px;\n}\n\n/* Set a style for all buttons */\n/*button {*/\n/*background-color: #333;*/\n/*color: white;*/\n/*padding: 15px 20px;*/\n/*margin: 8px 0;*/\n/*border: none;*/\n/*cursor: pointer;*/\n/*width: 100%;*/\n/*margin: auto;*/\n/*}*/\n\n/* Extra style for the cancel button (red) */\n.regisbtn {\n   width: auto;\n   padding: 10px 18px;\n   background-color: #f44336;\n}\n\n/* Center the avatar image inside this container */\n.imgcontainer {\n   text-align: center;\n   margin: 24px 0 12px 0;\n}\n\n/* Avatar image */\nimg.avatar {\n   width: 30%;\n   border-radius: 50%;\n   /*margin-top: 50px;*/\n}\n\n/* Add padding to containers */\n.container {\n   padding: 16px;\n}\n\n/* The \"Forgot password\" text */\nspan.psw {\n   float: right;\n   padding-top: 16px;\n}\n\n/* Change styles for span and cancel button on extra small screens */\n@media screen and (max-width: 300px) {\n   span.psw {\n      display: block;\n      float: none;\n   }\n\n   .cancelbtn {\n      width: 100%;\n   }\n\n}\n\n.wrapper {\n   text-align: center;\n   /*text-align: left;*/\n}\n\n.star {\n   font-size: 25px;\n   color: grey;\n}\n\nnav {\n   float: left;\n   max-width: 160px;\n   margin: 0;\n   padding: 1em;\n}\n\nnav ul {\n   list-style-type: none;\n   height: 100%;\n   position: fixed;\n   width: 15%;\n   background-color: #f4f5f7;\n   overflow: auto;\n}\n\nnav ul a {\n   text-decoration: none;\n   display: block;\n   color: #000;\n   padding: 8px 16px;\n}\n\n#div2, #div3, #div4 {\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n#snackbar {\n   visibility: hidden;\n   min-width: 250px;\n   margin-left: -125px;\n   background-color: #333;\n   color: #fff;\n   text-align: center;\n   border-radius: 2px;\n   padding: 16px;\n   position: fixed;\n   z-index: 1;\n   left: 50%;\n   bottom: 30px;\n   font-size: 17px;\n}\n\n#snackbar.show {\n   visibility: visible;\n   -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;\n   animation: fadein 0.5s, fadeout 0.5s 2.5s;\n}\n\n.errorBox.show {\n   visibility: visible;\n   -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;\n   animation: fadein 0.5s, fadeout 0.5s 2.5s;\n}\n\n@-webkit-keyframes fadein {\n   from {\n      bottom: 0;\n      opacity: 0;\n   }\n   to {\n      bottom: 30px;\n      opacity: 1;\n   }\n}\n\n@keyframes fadein {\n   from {\n      bottom: 0;\n      opacity: 0;\n   }\n   to {\n      bottom: 30px;\n      opacity: 1;\n   }\n}\n\n@-webkit-keyframes fadeout {\n   from {\n      bottom: 30px;\n      opacity: 1;\n   }\n   to {\n      bottom: 0;\n      opacity: 0;\n   }\n}\n\n@keyframes fadeout {\n   from {\n      bottom: 30px;\n      opacity: 1;\n   }\n   to {\n      bottom: 0;\n      opacity: 0;\n   }\n}\n\n#drop_zone.hover {\n   color: #f00;\n   border: solid #f00;\n   box-shadow: inset 0 3px 4px #888;\n}\n\n#drop_zone {\n   font-weight: bold;\n   text-align: center;\n   padding: 1em 0;\n   margin: 1em 0;\n   color: #555;\n   border: 2px dashed #555;\n   border-radius: 7px;\n   cursor: default;\n}\n\n#noFiles {\n   font-weight: bold;\n   text-align: center;\n   padding: 1em 0;\n   margin: 1em 0;\n   color: #555;\n   /*border: 2px dashed #555;*/\n   border-radius: 7px;\n   cursor: default;\n}\n\n#div1 {\n   width: 350px;\n   height: 70px;\n   padding: 10px;\n   border: 1px solid #aaa;\n}\n\n#body_drop_zone {\n   /*height: 65%;*/\n   /*overflow: auto;*/\n}\n\n#progressDlg {\n   /*animation: progressBar 3s ease-in-out;*/\n   /*animation-fill-mode:both;*/\n   -webkit-animation-name: example; /* Chrome, Safari, Opera */\n   -webkit-animation-duration: 5s; /* Chrome, Safari, Opera */\n   animation-name: example;\n   animation-duration: 5s;\n   animation-iteration-count: infinite;\n}\n\n@keyframes example {\n\n   0% {\n      background: #ff4d4d;\n   }\n   25% {\n      background: #f66;\n   }\n   50% {\n      background: #f99;\n   }\n   75% {\n      background: #ffe5e5;\n   }\n   100% {\n      background: #ff4d4d;\n   }\n\n   /*from {background-color:  #ff4d4d;}*/\n   /*to {background-color: #ff6666;}*/\n   /*to {background-color: #ff9999;}*/\n   /*to {background-color: #ffe5e5;}*/\n   /*to {background-color: white;}*/\n}\n\n#sideLeftdiv {\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n#sideLeft {\n   height: 65%;\n   overflow-y: auto;\n   /*overflow-x: hidden;*/\n}\n\n.modal-header {\n   padding: 10px;\n}\n\n.modal-footer {\n   padding: 10px;\n}\n\n/*@keyframes progressBar {*/\n/*!*0% { width: 0; }*!*/\n/*!*100% { width: 100%; }*!*/\n/**/\n/*}*/\n\n/*@-webkit-keyframes progressBar {*/\n/*0% {*/\n/*background: hsl(15, 0%, 52%);*/\n/*width: 0%;*/\n/*}*/\n/*70% {*/\n/*border-radius: 10px 0 0 10px;*/\n/*}*/\n/*100% {*/\n/*background: hsl(15, 100%, 72%);*/\n/*width: 100%;*/\n/*border-radius: 10px;*/\n/*}*/\n/*}*/\n\n.btnicon:before {\n   font-family: \"Glyphicons Halflings\", sans-serif;\n   content: \"\\e114\";\n   font-size: 14px;\n   margin-right: 5px\n}\n\n/* Icon when the collapsible content is hidden */\n.btnicon.collapsed:before {\n   content: \"\\e080\";\n}\n\nh5 {\n   /*width: 60%;*/\n   word-wrap: break-word;\n   font-family: Arial, Helvetica, sans-serif;\n   font-style: normal;\n}\n\n#sideBarLeft {\n   /*border: 2px solid;*/\n   /*padding: 20px;*/\n   width: 150px;\n   min-width: 150px;\n   max-width: 350px;\n   resize: horizontal;\n   overflow: hidden;\n   /*overflow: auto;*/\n}\n\n.disabledbutton {\n   background-color: gainsboro;\n   border-color: gainsboro;\n}\n\n.dlgProgress2 {\n   right: 20px;\n   top: 400px;\n   position: absolute;\n   height: auto;\n   min-width: 360px;\n   max-width: 400px;\n   background-color: #fff;\n   border: 1px solid #ccc;\n   box-shadow: 1px 0 8px rgba(0, 0, 0, 0.3);\n   color: #333;\n   /*margin-top: 3px;*/\n   z-index: 1000;\n}\n\n.floating-box {\n   float: left;\n   width: 300px;\n   height: 100px;\n   margin: 10px;\n   border: 3px solid #73ad21;\n}\n\n.after-box {\n   clear: left;\n   border: 3px solid red;\n}\n\n.modal-content {\n   margin: auto;\n   background-color: #fff;\n   position: relative;\n   padding: 0;\n   outline: 0;\n   width: 600px\n}\n\n.modal {\n   z-index: 100;\n   display: none;\n   padding-top: 100px;\n   position: fixed;\n   left: 0;\n   top: 0;\n   width: 100%;\n   height: 100%;\n   overflow: auto;\n   background-color: rgb(0, 0, 0);\n   background-color: rgba(0, 0, 0, 0.4)\n}\n\n.example-card {\n   width: 400px;\n   background-color: white;\n   left: 40%;\n   border: 1px solid #364150;\n}\n\n.example-section {\n   display: flex;\n   align-content: center;\n   align-items: center;\n   height: 60px;\n}\n\n.example-margin {\n   margin: 0 10px;\n}\n\n.header_modal {\n   /*border-bottom: 1px solid #364150;*/\n   border-bottom: 1px solid #999;\n}\n\n.header_modal p {\n   color: #364150;\n   font-size: 20px;\n   /*font-family: 'Open Sans';*/\n   /*font-weight: bold;*/\n}\n\n.footer_modal {\n   text-align: right;\n   margin-top: -15px;\n   /*margin: 5px*/\n}\n\n.footer_modal button {\n   /*font-family: 'Open Sans';*/\n   /*font-weight: bold;*/\n   margin-top: 10px;\n}\n\n#footerbutton {\n   border-top: 1px solid #364150;\n   margin-top: 10px;\n}\n\n.icon {\n   width: 27px;\n   height: 30px;\n   margin-right: 20px;\n   margin-bottom: -2px;\n   cursor: pointer;\n}\n\n.icon-two {\n   width: 27px;\n   height: 30px;\n   margin-right: 20px;\n   margin-bottom: -2px;\n   cursor: pointer;\n}\n\n.task-list {\n   width: 98%;\n   max-height: 100%;\n   transition: background-color .3s, opacity .3s;\n\n   display: flex;\n   flex-direction: column;\n   flex: 1;\n   overflow: auto;\n   position: relative;\n}\n\n.app-tasklist {\n   margin: 5px 20px 20px;\n   position: relative;\n   transition: background-color .3s, opacity .3s;\n}\n\n.mat-column-select {\n   overflow: visible;\n}\n\n.workflow-shadow {\n   box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0), 10px 0px 14px 0px rgba(0, 0, 0, 0.12);\n}\n\n.loading-shade {\n   position: absolute;\n   top: 0;\n   left: 0;\n   bottom: 56px;\n   right: 0;\n   background: rgba(0, 0, 0, 0.15);\n   z-index: 1;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n}\n\n.div-table {\n   overflow: auto !important;\n}\n\n.mat-form-field {\n   font-size: 14px;\n   width: 100%;\n}\n\ntable {\n   width: 100%;\n}\n\nth.mat-sort-header-sorted {\n   color: black;\n}\n\n.task-row {\n   overflow: auto;\n   height: 10px;\n}\n\n/*.taskname {*/\n/*   display: flex !important;*/\n/*   text-overflow: ellipsis;*/\n/*   white-space: nowrap;*/\n/*   overflow: hidden !important;*/\n/*   max-width: calc(30em * 0.5);*/\n/*   min-width: 100%;*/\n/*}*/\n.taskname {\n   overflow: hidden;\n   white-space: nowrap;\n   text-overflow: ellipsis;\n}\n\n.taskname-content {\n   display: flex;\n   align-items: center;\n   width: 100%;\n   overflow: hidden;\n}\n\n.file-icon img {\n   display: block;\n   margin: 8px;\n   width: 22px;\n   height: 22px;\n   object-fit: contain;\n}\n.file-icon img.cover {\n   object-fit: cover;\n}\n.file-filename {\n   padding: 10px 0;\n}\n.file-filename a {\n   cursor: pointer;\n}\n.file-name {\n   align-items: center;\n   display: inline-flex;\n   max-width: 100%;\n}\n.file-name a, .file-name .name {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n.file-name .link {\n   fill: #ba68c8;\n   cursor: pointer;\n   display: inline-block;\n   margin-left: 10px;\n   width: 14px;\n   height: 14px;\n}\n.item-top {\n   vertical-align: top;\n   padding-top: 8px;\n}\n\n.container-new-task {\n   flex: 1;\n   background: #fff;\n   margin: 50px 10px 10px;\n}\n\n.right-panel {\n   background: #fff;\n   width: 320px;\n   min-width: 320px;\n   overflow-y: auto;\n   transition: margin-right .2s;\n}\n\n.content-panel {\n   display: flex;\n   flex-direction: column;\n   margin: 0px 10px;\n}\n\n.sub-header {\n   color: #aaa;\n}\n\n.content-panel img {\n   width: 22px;\n   height: 22px;\n   position: absolute;\n   left: -22px;\n   top: 4px;\n}\n\n.content-panel ul {\n   list-style: none;\n   margin: 10px 0 0;\n   padding: 0;\n}\n\n.content-panel li {\n   margin: 5px 0 5px 5px;\n   line-height: 20px;\n   position: relative;\n}\n\n.content-panel li.section {\n   font-weight: bold;\n   padding: 5px 5px 5px 20px;\n}\n\n.content-panel a{\n   color: #666;\n   display: flex;\n   line-height: 20px;\n   padding: 5px 5px 5px 0;\n   position: relative;\n}\n\n.content-panel a:hover {\n   color: #ffa726;\n   cursor: pointer;\n   background-color: #f7f7f7;\n   text-decoration: none;\n}\n\n.content-panel a:active {\n   color: #ff8326;\n   cursor: default;\n}\n\n.content-panel a.active {\n   color: #ff8326;\n   cursor: default;\n}\n\n.content-panel a.active:hover {\n   text-decoration: none;\n}\n\n.content_header {\n   width: 100%;\n   position: sticky;\n   top: 0;\n   z-index: 999;\n   background: #FFFFFF;\n   padding-bottom: 10px;\n}\n\n.isDisabled {\n   cursor: not-allowed;\n   opacity: 0.5;\n }\n .isDisabled > a {\n   color: currentColor;\n   display: inline-block;  /* For IE11/ MS Edge bug */\n   pointer-events: none;\n   text-decoration: none;\n }\n.itemMenu-img {\n   margin-right: 14px !important;\n   object-fit: contain;\n}\n\n::ng-deep .sub-menu-export svg {\n   margin-right: auto;\n}\n\n.sub-menu-export {\n   padding-right: 30px;\n}\n.group-by{\n   z-index: 1;\n   margin: 0 0 0 10px!important;\n   white-space: nowrap;\n}\n.flex-container {\n   float: right!important;\n   display: flex;\n   align-items: center;\n   justify-content: flex-end;\n}\n\n#paginator {\n   flex: 0 0 auto;\n}\n\n::ng-deep #paginator .range {\n   white-space: nowrap;\n}\n\n.mat-column-select {\n   width: 36px;\n   max-width: 36px;\n   min-width: 36px;\n   padding: 0 !important;\n   text-align: center;\n}\n.checkbox-wrapper {\n   display: flex;\n   align-items: center;\n   justify-content: center;\n}\n\n.checkbox-wrapper mat-checkbox {\n   margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
